import { useState } from "react";
import { Minus } from "lucide-react";
import { Plus } from "./Icons";

const faqs = [
  {
    question: "What tools and software will I need to complete the course?",
    answer:
      "You will need a computer with internet access and a code editor. Additional tools will be provided during the course.",
  },
  {
    question: "Can I access the course materials after I finish the course?",
    answer:
      "Yes, you will have lifetime access to the course materials even after completion.",
  },
  {
    question: "Will I receive a certificate upon completion of the course?",
    answer:
      "Yes, a certificate will be provided once you successfully complete the course.",
  },
  {
    question:
      "Do I need prior experience in web design to enroll in this course?",
    answer:
      "No prior experience is required. This course is beginner-friendly.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className=" px-8 lg:px-12 pt-10 lg:pt-14 xl:pt-20 2xl:pt-[106px]">
      <div className="max-w-[1558px] mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-[40px] font-normal  md:leading-[48px] lg:leading-[56px]">
          Frequently Asked Questions
        </h2>
        <p className="leading-[19px] mt-2">
          Everything you need to know about our course
        </p>

        <div className="space-y-6 md:space-y-8 lg:space-y-12 2xl:space-y-[60px]  py-9 md:py-11 ">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-black px-4 lg:px-6 ">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex justify-between gap-5 items-center py-6 lg:py-[29px] text-left"
              >
                <span className="font-normal text-xl leading-[22px]">
                  {faq.question}
                </span>
                {openIndex === index ? <Minus size={18} /> : <Plus />}
              </button>

              {openIndex === index && (
                <div className="px-4 pb-4 text-gray-600">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
